<template lang="">
    <div>
        <p v-html="detail.product_content"></p>
        <div>123123</div>
      <!-- <mask-pop>
           <div class="pop">
            <div class="gundong">
               
        
            </div>
        </div>
      </mask-pop> -->
    </div>
</template>
<script>
// import maskPop from "@/components/maskPop"
export default {
    components:{
        // maskPop
    },
    data(){
        return{
            detail:{}
        }
    },
    created(){
        this.detail = JSON.parse(window.localStorage.getItem("detail"))
    }
    
}

</script>
<style lang="scss">
     
        
</style>